import { useEffect } from 'react';
import { ComingSoonText } from '../../coming-soon/ComingSoonText';

export const StakingTab = () => {
  useEffect(() => {
    window.open('https://www.undeadblocks.com/staking', '_blank');
  }, []);
  return <ComingSoonText title={`The Staking tab`} />;
};
